import * as Sentry from "@sentry/react";
import * as React from 'react'
import ReactDOM from 'react-dom/client'
import {
  ErrorComponent,
  RouterProvider,
  createRouter,
  Outlet
} from '@tanstack/react-router'
import { getQueryClient } from "./providers/query.provider";
import { routeTree } from './routeTree.gen'
import { useAuth } from "./providers/auth.provider";

import { LoadingOverlay } from '@workspace/web-ui/components/loading-overlay';
import { cn } from '@workspace/web-ui/lib/utils';

import '@fontsource-variable/inter';

import "@workspace/web-ui/globals.css";
import "~/utils/index"
import './index.css'

export const queryClient = getQueryClient()

const router = createRouter({
  routeTree,
  defaultPendingComponent: () => (
    <div className="relative flex min-h-screen flex-1" role="main">
      <LoadingOverlay
        isLoading={true}
        showLoader={true}
        variant="light"
        aria-busy={true}
      />
      <div
        className={cn(
          "flex w-full transition-opacity duration-200",
          {
            "pointer-events-none select-none opacity-50": true,
          }
        )}
        aria-hidden={true}
      >
        <Outlet />
      </div>
    </div>
  ),
  defaultErrorComponent: ({ error }) => <ErrorComponent error={error} />,
  context: {
    auth: undefined!,
    queryClient,
  },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
})

Sentry.init({
  dsn: "https://f7ec9a49206106ddb1653fb47e988682@o4509269617868800.ingest.us.sentry.io/4509271201087488",
  integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],
  tracesSampleRate: 1.0,
  sendDefaultPii: true
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

function App() {
  return (
    <>
      <RouterProvider
        router={router}
        defaultPreload="intent"
        context={{
          auth: useAuth(),
        }}
      />
    </>
  )
}

const rootElement = document.getElementById('app')!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}